import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import PropTypes from 'prop-types';

class AutocompleteFirmValidation extends Component {
	state = {
		value: '',
		suggestions: [],
		errors: []
	}

	getSuggestionValue = suggestion => suggestion.name;

	renderSuggestion = suggestion => (
		<div>
			{suggestion.name}
		</div>
	)

	onChange = (event, { newValue }) => {
		this.props.onChange(newValue);
		this.setState({
			value: newValue,
			errors: []
		});
	}

	onSuggestionsFetchRequested = ({ value }) => {
		this.props.getSuggestions(value)
			.then(response => {
				if (response.success) {
					this.setState({
						suggestions: response.data
					});
				}
			})
			.catch(error => console.error(error));
	}

	onSuggestionsClearRequested = () => {
		this.setState({
			suggestions: []
		});
	}

	onSelect = (e, {suggestion}) => {
		this.setState({
			error: 'Данная организация уже существует: ' + suggestion.name
		});
		this.props.onSelect(suggestion);
	}

	render () {
		const { value, suggestions, error } = this.state;

		const inputProps = {
			placeholder: 'Введите первые буквы в названии',
			value,
			onChange: this.onChange
		};

		return (
			<div>
				<Autosuggest
					suggestions={suggestions}
					onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
					onSuggestionsClearRequested={this.onSuggestionsClearRequested}
					getSuggestionValue={this.getSuggestionValue}
					renderSuggestion={this.renderSuggestion}
					inputProps={inputProps}
					onSuggestionSelected={this.onSelect}
				/>
				{ error ? <p className="firm--exist">{error}</p> : null }
			</div>
		);
	}
}

AutocompleteFirmValidation.propTypes = {
	getSuggestions: PropTypes.func.isRequired,
	onSelect: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired
}

export default AutocompleteFirmValidation;



// WEBPACK FOOTER //
// ./components/AutocompleteFirmValidation.js